import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import SideBar from '../SideBar';
import Loaders from '../Loaders';
import { StyledLayout, MainColumn, MainContent, AuthLayoutWrap } from './Layout.styles';

const Layout = ({ children, showTemplate }) => {
  const location = useLocation();
  const isChatRoute = location.pathname === '/chat' || location.pathname.startsWith('/chat/');

  // Auth / onboarding pages (login, signup, etc.) — keep original wrapper unchanged
  if (!showTemplate) {
    return (
      <div className="wrapper">
        <AuthLayoutWrap>
          <span className="overlay" />
          <div className="children">{children}</div>
        </AuthLayoutWrap>
      </div>
    );
  }

  // Authenticated app shell — reference structure, Gramie branding
  return (
    <StyledLayout $showlayout>
      <SideBar />
      <MainColumn>
        <MainContent $isChatRoute={isChatRoute}>
          <Suspense fallback={<Loaders viewLoader />}>{children}</Suspense>
        </MainContent>
      </MainColumn>
    </StyledLayout>
  );
};

export default Layout;
